import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const ImgTitBanner = styled.div`
  .veVideo {
    .xgplayer {
      line-height: 0;
    }

    video {
      position: relative;
      max-height: ${mixin.pxToVw('500')};
    }
  }

  .btn:has(.img-tit-banner) {
    width: 100%;
  }

  .img-tit-banner {
    img {
      position: relative !important;
      max-height: ${mixin.pxToVw('500')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    width: 1440px;
    margin: 0 auto;

    .veVideo video,
    .img-tit-banner img {
      max-height: 720px;
    }
  }
`;
